import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

require('../node_modules/bootstrap/dist/css/bootstrap.css')
require('./assets/css/custom.css')

createApp(App).use(store).use(router).mount('#app')
